// extracted by mini-css-extract-plugin
module.exports = {"issued":"WearableDetail_issued__2iDQE"};